import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { Modal, Button } from 'react-bootstrap';
import styles from './InsufficientBalanceModal.module.scss';
import { ReactComponent as IconTowerLogoMedium } from '../../assets/icons/logo-tower-no-bg.svg';
import { useHistory } from 'react-router-dom';


const InsufficientBalanceModal = (props) => {

    const { show, closeModal, title, description, buttonText } = props.content || {};
    const history = useHistory();
    return (
        <Modal show={show} dialogClassName={styles.insufficient_balance_modal} contentClassName={styles.background_modal_body} onHide={closeModal} centered>
            <div className={styles.close_btn} onClick={closeModal}><FontAwesomeIcon icon={faTimes}/></div>
            <Modal.Header className={styles.insufficient_balance_modal_header}>
                {title}
            </Modal.Header>
            <Modal.Body className={styles.insufficient_balance_modal_body}>
                {description}
            </Modal.Body>
            <Modal.Footer className={styles.insufficient_balance_modal_footer}>
                <Button variant="cdh-general-blue" className={styles.ok_btn} onClick={() => history.push('/buy-tower/matic')}>
                    <div className={styles.tower_logo}>
                        <IconTowerLogoMedium fill="#fff" className={styles.tower_img} />
                    </div>
                    <div className={styles.btn_text}>{buttonText}</div>
                </Button>
            </Modal.Footer>
        </Modal>
  )
}

export { InsufficientBalanceModal };